import { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "umi";
import dailyFilterDefault from "@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault";
import { getPcV3DailyCountryRegionPlatform } from "@/pages/dashboard/services/overview";
import { PERIODTIMEOBJ } from "@/pages/dashboard/_config/constant";
import { IsSingleDay, addLastDateRequestValue } from "@/pages/dashboard/utils/utils";

const metricReqObj: { [key: string]: string; } = {
  dau: 'dau',
  wau: 'wau',
  mau: 'mau',
  mtx_revenue: 'mtx_revenue',
  new: 'new',
  units: 'units',
  revenue: 'platform_net_revenue',
  inflexion_new_churn: 'new_churn',
  mtx_revenue_v4: 'mtx_revenue'
};
const useData = (
  filterVal: any,
  filterLoading: boolean,
  api: string,
  period: string,
  by_type: string,
  metric: string,
  chartDataKey: string,
  tableDataKey: string,
  haveLastDate?: boolean,
  timeZone?: number,
  extraParams?: Record<string, any>
) => {
  const formVal = filterVal || dailyFilterDefault;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);
  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    if (!filterLoading) {
      getPcDailyCountryRegionPlatformDataFunc();
    }
  }, [formVal, by_type, metric]);

  const getPcDailyCountryRegionPlatformDataFunc = () => {
    const { rangeTime: [start, end], diff, timeType, ...filters } = filterVal;

    let params = {
      game_code: gameCode,
      start_time: start,
      end_time: end,
      period,
      filters,
      by_type,
      metric: metricReqObj?.[metric] || metric,
      ...extraParams
    };
    params = addLastDateRequestValue(params, haveLastDate, timeZone);
    // 由于有些排行后端返回的数据不一样名称，所以这里加了一个配置，默认是'dwm'
    const configChartDataKey = chartDataKey || 'dwm_data_list';
    const configTableDataKey = tableDataKey || 'dwm_list';
    setLoading(true);
    getPcV3DailyCountryRegionPlatform(api, params).then((result: any) => {
      setError(false);
      setLoading(false);
      setData({
        chartData: result?.[configChartDataKey] || [],
        tableData: result?.[configTableDataKey] || [],
      });
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };

  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    data,
    loading,
    error,
    isSingle: IsSingleDay({ ...filterVal, period: PERIODTIMEOBJ[filterVal?.timeType] }),
    getData: getPcDailyCountryRegionPlatformDataFunc
  };
};

export default useData;